import { useNavigate, useParams } from "react-router-dom";
import { floatToPercent, floatToPrice } from "../../functions/price_functions";
import "./index.css";
import { useProduct } from "../../hooks/useProduct";
import Swal from "sweetalert2";
import { useEffect, useState } from "react";
import { DiscountFlag } from "../DiscountFlag";
import { useAppConfig } from "../../hooks/useAppConfig";

type DiscountDataType = {
  type: string;
  color: string;
};

type PDVItemProps = {
  id: number | string;
  name: string;
  reference_id: string;
  price: number;
  promotionalPrice: number;
  image: string;
  inBlocks: boolean;
  fontColor: string;
  description: string;
  discountCoupon: DiscountDataType;
  food?: boolean;
  noImage?: boolean;
  type?: string;
  hasDiscount?: boolean;
  discountValue?: string;
  clickFunction?: () => any;
  stock: boolean;
  mark: string;
  isVertical?: boolean;
};

export function PDVItem({
  id,
  name,
  reference_id,
  price,
  promotionalPrice,
  image,
  inBlocks,
  fontColor,
  description,
  discountCoupon,
  food,
  noImage,
  type,
  clickFunction,
  hasDiscount,
  discountValue,
  stock,
  mark,
  isVertical = false,
}: PDVItemProps) {
  const navigate = useNavigate();
  const { getAppConfig } = useAppConfig();
  const { pluginspace_id } = useParams();
  const { selectProduct } = useProduct();
  const [loadingImage, setLoadingImage] = useState(true);
  const [showFlag, setShowFlag] = useState<boolean>(true);
  const [typeFlagDiscount, setTypeFlagDiscount] = useState<undefined | String>(
    undefined
  );
  const [showMarkup, setShowMarkup] = useState(false);
  const [showInventory, setShowInventory] = useState(false);

  const imageFrameStyle = isVertical
    ? { width: "120px", height: "180px" } // proporção 600x900
    : { width: "120px", height: "120px" }; // proporção 640x640

  function selectProductItem() {
    if (clickFunction) clickFunction();
    if (food) {
      navigate(`/${pluginspace_id}/products/${id}`);
    } else {
      selectProduct(id.toString());

      let url = `/${pluginspace_id}/product/${id}`;

      if (hasDiscount && discountValue && parseInt(discountValue) > 0) {
        url += `?discount=${window.btoa(discountValue.toString())}`;
      }
      navigate(url);
    }
  }

  async function load() {
    const config = await getAppConfig();
    const showFlag = config?.content.showFlagDiscount || false;
    setShowFlag(showFlag);

    const typeFlagDiscount =
      showFlag && config?.content.flagDiscount
        ? config.content.flagDiscount
        : undefined;

    setTypeFlagDiscount(typeFlagDiscount);

    if (config) {
      const showMarkup = config?.content.showProductMark || false;
      const showInventory = config?.content.showProductInventory || false;
      setShowInventory(showInventory);
      setShowMarkup(showMarkup);
    }
  }

  useEffect(() => {
    load();
  }, []);

  return (
    <div
      className={inBlocks ? "pdv-item" : "pdv-item-list"}
      style={noImage && inBlocks ? { height: "14em" } : {}}
      onClick={() => selectProductItem()}
    >
      {inBlocks ? (
        <>
          {!noImage && (
            <div
              className="pdv-image"
              style={{
                ...imageFrameStyle,
                border: noImage ? "none" : undefined,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                overflow: "hidden",
              }}
            >
              {image ? (
                <>
                  {loadingImage && <div className="no-image" />}
                  <div className="pdv-image-item">
                    <img
                      style={
                        loadingImage
                          ? { visibility: "hidden", width: 0, height: 0 }
                          : isVertical
                          ? {
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                              borderRadius: "10px",
                            }
                          : {
                              width: "100%",
                              objectFit: "contain",
                              borderRadius: "10px",
                            }
                      }
                      src={image}
                      alt={name}
                      onLoad={() => setLoadingImage(false)}
                    />
                  </div>
                </>
              ) : (
                <div className="no-image" />
              )}
              {showFlag && promotionalPrice && promotionalPrice !== price ? (
                <DiscountFlag
                  type={typeFlagDiscount as unknown as string}
                  color={discountCoupon.color}
                  value={Math.floor(((price - promotionalPrice) / price) * 100)}
                  isList={false}
                />
              ) : (
                <></>
              )}
            </div>
          )}
          <div className="pdv-content">
            <div className="texts">
              <p
                style={{ color: fontColor, fontWeight: food ? "bold" : "400" }}
              >
                {food
                  ? name.toUpperCase()
                  : name.length > 30
                  ? name.substring(0, 27) + "..."
                  : name}
              </p>
              <p
                style={{
                  color: fontColor,
                  fontSize: food ? 10 : 14,
                  marginTop: food ? "1em" : "",
                }}
              >
                {food ? (
                  description
                ) : (
                  <>
                    <b style={{ fontWeight: "600" }}>REF </b>
                    {reference_id}
                  </>
                )}
              </p>
              {!food && (
                <>
                  {showMarkup && (
                    <p
                      style={{
                        color: fontColor,
                        fontSize: food ? 10 : 14,
                        marginTop: food ? "1em" : "",
                      }}
                    >
                      <b style={{ fontWeight: "600" }}> Marca:</b> {mark}
                    </p>
                  )}
                  {showInventory && (
                    <p
                      style={{
                        color: fontColor,
                        fontSize: food ? 10 : 14,
                        marginTop: food ? "1em" : "",
                      }}
                    >
                      <b style={{ fontWeight: "600" }}> Disp:</b>{" "}
                      {stock ? "Em estoque" : "Sem estoque"}
                    </p>
                  )}
                </>
              )}
            </div>
            {promotionalPrice && promotionalPrice !== price ? (
              <div className="promotional-prices">
                <p className="old-price" style={{ color: fontColor + "77" }}>
                  {floatToPrice(price)}
                </p>
                <p className="price" style={{ color: fontColor }}>
                  {floatToPrice(promotionalPrice)}
                </p>
                {/*
                <div
                  className="discount-text"
                  style={{ backgroundColor: discountCoupon.color }}
                >
                  <p>
                    <b>
                      {parseInt(
                        (((price - promotionalPrice) / price) * 100).toFixed(2)
                      )}
                      %
                    </b>{" "}
                    off
                  </p>
                </div>
                
                */}
              </div>
            ) : (
              <div className="promotional-prices">
                <p className="price" style={{ color: fontColor }}>
                  {floatToPrice(price)}
                </p>
              </div>
            )}
          </div>
        </>
      ) : (
        <>
          {noImage ? (
            <></>
          ) : (
            <div
              className="pdv-image-list"
              style={{
                ...imageFrameStyle,
                border: noImage ? "none" : undefined,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                overflow: "hidden",
              }}
            >
              {image ? (
                <>
                  {loadingImage && (
                    <div className="loading-image" id={`product-image-${id}`} />
                  )}
                  <div className="pdv-image-item-list">
                    <img
                      style={
                        loadingImage
                          ? { visibility: "hidden", width: 0, height: 0 }
                          : isVertical
                          ? {
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                              borderRadius: "10px",
                            }
                          : {
                              width: "100%",
                              objectFit: "contain",
                              borderRadius: "10px",
                            }
                      }
                      src={image}
                      alt={name}
                      onLoad={() => setLoadingImage(false)}
                    />
                  </div>
                </>
              ) : (
                <div />
              )}

              {showFlag && promotionalPrice && promotionalPrice !== price ? (
                <DiscountFlag
                  type={typeFlagDiscount as unknown as string}
                  color={discountCoupon.color}
                  value={Math.floor(((price - promotionalPrice) / price) * 100)}
                  isList={true}
                />
              ) : (
                <></>
              )}
            </div>
          )}

          <div
            className="pdv-content-list"
            style={
              food && !inBlocks
                ? {
                    textAlign: "start",
                    alignItems: "start",
                    width: "100%",
                    marginLeft: "1em",
                    maxHeight: "8.5em",
                    overflowY: "auto",
                  }
                : { textAlign: "start", alignItems: "start" }
            }
          >
            <div className="texts">
              <p
                style={{ color: fontColor, fontWeight: food ? "bold" : "400" }}
              >
                {food
                  ? name.toUpperCase()
                  : name.length > 30
                  ? name.substring(0, 27) + "..."
                  : name}
              </p>
              <p
                className="ref-item"
                style={{
                  color: fontColor,
                  fontSize: food ? 10 : 14,
                  marginTop: food ? "1em" : "",
                }}
              >
                {food ? (
                  description
                ) : (
                  <>
                    <b style={{ fontWeight: "600" }}>REF </b>
                    {reference_id}
                  </>
                )}
              </p>
              {!food && (
                <>
                  {showMarkup && (
                    <p
                      style={{
                        color: fontColor,
                        fontSize: food ? 10 : 14,
                        marginTop: food ? "1em" : "",
                      }}
                    >
                      <b style={{ fontWeight: "600" }}> Marca:</b> {mark}
                    </p>
                  )}
                  {showInventory && (
                    <p
                      style={{
                        color: fontColor,
                        fontSize: food ? 10 : 14,
                        marginTop: food ? "1em" : "",
                      }}
                    >
                      <b style={{ fontWeight: "600" }}> Disp:</b>{" "}
                      {stock ? "Em estoque" : "Sem estoque"}
                    </p>
                  )}
                </>
              )}
            </div>

            {type === "fractional" ? (
              `A partir de ${floatToPrice(price)}`
            ) : (
              <>
                {promotionalPrice && promotionalPrice !== price ? (
                  <div className="promotional-prices">
                    <p
                      className="old-price"
                      style={{ color: fontColor + "77" }}
                    >
                      {floatToPrice(price)}
                    </p>
                    <p className="price" style={{ color: fontColor }}>
                      {floatToPrice(promotionalPrice)}
                    </p>
                    {/*
                      
                                            <div
                        className="discount-text"
                        style={{ backgroundColor: discountCoupon.color }}
                      >
                        <p>
                          <b>
                            {parseInt(
                              (
                                ((price - promotionalPrice) / price) *
                                100
                              ).toFixed(2)
                            )}
                            %
                          </b>{" "}
                          off
                        </p>
                      </div>
                      */}
                  </div>
                ) : (
                  <div className="promotional-prices">
                    <p className="price" style={{ color: fontColor }}>
                      {floatToPrice(price)}
                    </p>
                  </div>
                )}
              </>
            )}
          </div>
        </>
      )}
    </div>
  );
}
